export default __webpack_public_path__ + "static/media/nutritional_table.b1cfdc71.png";